import { Form, Col, Row, Checkbox } from "antd";
import { FormInstance } from "antd/lib/form/Form";
import Title from "antd/lib/typography/Title";
import React from "react";
import { DataGrid } from "@core-ui/datagrid";
import { TOrganisationIndexPresentationModel } from "../../presenter/model/OrganisationIndexPresentationModel";
import OrganisationIndexTag from "./OrganisationIndexTag";
import FormLabel from "../../../core/ui/components/FormLabel";

interface OrganisationIndexConnectionFormProps {
  translate: any;
  referenceLoader?: boolean;
  indexes: TOrganisationIndexPresentationModel[];
  toggleConnected: any;
  form: FormInstance;
  clickedIndex?: TOrganisationIndexPresentationModel;
  searchFunction: any;
  toggleFilterByParentName?: any;
  description: string;
}
const OrganisationIndexConnectionForm: React.FC<OrganisationIndexConnectionFormProps> =
  ({
    translate,
    indexes,
    toggleConnected,
    form,
    clickedIndex,
    searchFunction,
    toggleFilterByParentName,
    description
  }) => {
    const changeConnected = (index, e) => {
      toggleConnected(index, e.target.checked);
    };

    const columns = [
      {
        title: translate("editors.organisation_indexes.descriptor"),
        key: "name",
        dataIndex: "name",
        render: (text, data: TOrganisationIndexPresentationModel) => (
          <div>
            {data?.pathToIndex?.length > 0 ? (
              <OrganisationIndexTag
                indexHierarchyList={data?.pathToIndex || []}
                style={{
                  justifyContent: "flex-start",
                  width: "20em"
                }}
              />
            ) : (
              <OrganisationIndexTag
                indexHierarchyList={[data?.name]}
                style={{
                  justifyContent: "flex-start",
                  width: "20em"
                }}
              />
            )}
          </div>
        )
      },
      {
        title: translate("editors.organisation_indexes.organisation"),
        key: "organisation",
        dataIndex: ["organisation", "name"]
      },
      {
        title: translate("editors.organisation_indexes.type"),
        key: "type",
        dataIndex: ["indexType", "name"]
      },
      {
        title: translate("editors.organisation_indexes.connected"),
        key: "connected",
        render: (record) => (
          <div>
            <Checkbox
              style={{ margin: "0.5em" }}
              checked={record.connected}
              onChange={(e) => changeConnected(record, e)}
            />
          </div>
        )
      }
    ];

    return (
      <Form form={form}>
        <Row className={"datagrid-header"}>
          <Col lg={18} sm={13}>
            <Title level={1} className={"datagrid-title"}>
              {translate("editors.organisation_indexes.title")}
            </Title>
          </Col>
        </Row>
        <Row>
          <div style={{ marginTop: "1em", marginBottom: "2.5em" }}>
            {description}
          </div>
        </Row>
        {toggleFilterByParentName && (
          <Row>
            <div style={{ marginBottom: "1em", display: "flex" }}>
              <FormLabel
                text={translate(
                  "editors.organisation_indexes.filter_by_parent_name"
                )}
              />
              <Checkbox
                style={{ marginLeft: "1em" }}
                onChange={(e) => toggleFilterByParentName(e.target.checked)}
              />
            </div>
          </Row>
        )}
        <Row>
          <Col span={24}>
            <DataGrid
              tableFormManager={{
                columns: columns,
                dataSource: indexes,
                keyProperty: "id",
                locale: {}
              }}
              headerFormManager={{ title: "" }}
              searchFormManager={{
                searchEnabled: true,
                searchTablePlaceholder: translate(
                  "editors.organisation_indexes.search_label"
                ),
                searchFunction: searchFunction
              }}
              pagingFormManager={{
                dataSource: indexes,
                itemsPerPageLabel: "",
                showingLabel: translate(
                  "editors.organisation_indexes.showing_label"
                ),
                totalLabel: translate(
                  "editors.organisation_indexes.total_label"
                ),
                toLabel: translate("editors.organisation_indexes.to_label"),
                pageSize: 10
              }}
              deleteModalFormManager={{}}
              createModalFormManager={{}}
              updateModalFormManager={{}}
            />
          </Col>
        </Row>
      </Form>
    );
  };
export default OrganisationIndexConnectionForm;
